import React from "react";
import Format from "../../Format";
import { useGlobalValue } from "../../../state/GlobalProvider";
import { createLink, date, format } from "../../../utils";
import LinkButton from "../../LinkButton/LinkButton";
import Icon from "../../Icon/Icon";
import styles from "./CardRow.module.sass";
const statusColor = {
  n_progress: "lightBlue",
  submitted: "gray",
  sending_to_inbox: "lightBlue",
  uploaded: "gray",
  checking_file: "lightBlue",
  xsd_checking: "lightBlue",
  saving_to_db: "lightBlue",
  test_running: "lightBlue",
  invalid: "red",
  imported: "green",
  canceled: "yellow",
  deleting: "yellow",
  deleted: "yellow",
  error: "red",
  ok: "ok"
};
const CardRow = props => {
  // TODO: use prop filter to highlight corresponding row
  const {
    data
  } = props;
  const {
    i18n,
    proxy,
    pushDialog,
    deleteFile,
    user,
    params
  } = useGlobalValue();
  const {
    fiscalYear,
    projectId
  } = params;
  const columns = ((data || {}).card || []).map((column, index) => {
    if (!column) {
      return null;
    }
    let alignment = "";
    const rows = column.map((row, rowIndex) => {
      if (!row) {
        return null;
      }
      const {
        type,
        value,
        template,
        values
      } = row;
      let rowValue = value;
      let valueElement;
      if (template && values) {
        rowValue = i18n(template, ...values);
      }
      switch (type) {
        case "number":
          {
            alignment = alignment !== "align-center" ? "align-center" : alignment;
            valueElement = `${rowValue && rowValue != "null" ? format(rowValue, "normal", null) : "N/A"}`;
            break;
          }
        case "unity":
          {
            alignment = alignment !== "align-right" ? "align-right" : alignment;
            valueElement = `${rowValue || "N/A"}`;
            break;
          }
        case "percentage":
          {
            alignment = alignment !== "align-right" ? "align-right" : alignment;
            valueElement = `${format((parseFloat(rowValue) || 0).toFixed(2), "normal", null)}%`;
            break;
          }
        case "status":
          {
            alignment = alignment !== "align-center" ? "align-center" : alignment;
            valueElement = rowValue && rowValue !== null ? rowValue : "N/A ";
            break;
          }
        case "date":
          {
            alignment = alignment !== "align-center" ? "align-center" : alignment;
            valueElement = rowValue || "N/A";
            break;
          }
        case "datetime":
          {
            alignment = "align-center";
            valueElement = rowValue || "N/A";
            break;
          }
        case "date_interval":
          {
            alignment = alignment !== "align-center" ? "align-center" : alignment;
            valueElement = rowValue ? rowValue.map(v => date(v)).join(" - ") : "N/A";
            break;
          }
        case "currency":
          {
            alignment = alignment !== "currency align-right" ? "currency align-right" : alignment;
            valueElement = /*#__PURE__*/React.createElement(Format, {
              type: type,
              value: rowValue || 0
            });
            break;
          }
        case "object":
          {
            alignment = alignment !== "align-center" ? "align-center" : alignment;
            if (rowValue.id && rowValue.name) {
              valueElement = /*#__PURE__*/React.createElement(LinkButton, {
                to: createLink(undefined, proxy, rowValue, params),
                label: rowValue.name
              });
            } else {
              valueElement = `${rowValue || "--"}`;
            }
            break;
          }
        case "periods":
          {
            let arrayMonths = Array(12).fill(false);
            alignment = alignment !== "align-center" ? "align-center" : alignment;
            rowValue.map(p => arrayMonths[p - 1] = true);
            valueElement = arrayMonths.map((period, i) => {
              return /*#__PURE__*/React.createElement("div", {
                key: i,
                className: period ? styles[statusColor["ok"]] : ""
              }, period);
            });
            break;
          }
        case "deleteFile":
          {
            alignment = alignment !== "align-right" ? "align-right" : alignment;
            if (rowValue === "invalid" || rowValue === "imported" || rowValue === "error") {
              valueElement = /*#__PURE__*/React.createElement("div", {
                className: styles["action-delete"]
              }, /*#__PURE__*/React.createElement(LinkButton, {
                label: /*#__PURE__*/React.createElement(Icon, {
                  name: "remove",
                  className: `${styles["btn"]} ${styles[`icon-trash-can`]}`
                }),
                onClick: () => {
                  pushDialog && pushDialog({
                    title: "Remove File",
                    text: "Do you really to want to delete?",
                    fnc: () => deleteFile && deleteFile({
                      fiscalYear,
                      projectId,
                      userId: user.id,
                      dataFileId: data.id,
                      status: rowValue
                    })
                  }, "ConfirmViewer");
                }
              }));
            }
            break;
          }
        default:
          {
            alignment = "align-left";
            valueElement = `${rowValue && rowValue != "null" ? rowValue : "N/A"}`;
            break;
          }
      }
      const Tag = type === "object" ? "div" : rowIndex === 0 ? "h5" : "small";
      return /*#__PURE__*/React.createElement(Tag, {
        key: rowIndex,
        className: `
							${alignment}
							${type === "status" ? styles["statusColor"] + " " + styles[statusColor[rowValue]] : ""}
							${type === "periods" ? styles["periods"] : ""}
						`
      }, valueElement);
    });
    return /*#__PURE__*/React.createElement("span", {
      key: index,
      className: styles["column"]
    }, rows);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles["row"]
  }, columns);
};
export default CardRow;